import type { RouterConfig } from "@nuxt/schema";

import ModelPost from "~/views/model/Post.vue";
import PageNotFound from "~/views/PageNotFound.vue";

function __redirectToOriginal(to: { fullPath: string }) {
  if (process.server) return;
  window.location.href = useRuntimeConfig().public.REAL_URL + to.fullPath;
}

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
  routes: (_routes) => [
    { name: "home", beforeEnter: __redirectToOriginal },
    {
      path: "/purchase",
      redirect: { name: "home" },
      children: [
        {
          name: "purchase.tokens",
          path: "tokens",
          beforeEnter: __redirectToOriginal,
        },
      ],
    },
    {
      children: [
        {
          name: "webstars.search",
          path: "/webstar/search",
          beforeEnter: __redirectToOriginal,
        },
      ],
    },
    { name: 'dashboard',      path: '/dashboard',          
    beforeEnter: __redirectToOriginal,// component: Dashboard,      
    meta: {auth: true} },


    { name: 'login',          path: '/login',              
    beforeEnter: __redirectToOriginal, // component: LoginRegister,  
    meta: {auth: false} },

    {
      path: '/signup',
      meta: { auth: false },
      children: [
          { name: 'signup',      path: '/',     beforeEnter: __redirectToOriginal },
          { name: 'signup.user', path: 'user',  beforeEnter: __redirectToOriginal },
      ]
  },

    { name: "support", path: "/support", beforeEnter: __redirectToOriginal },

    { name: "faqs", path: "/faqs", beforeEnter: __redirectToOriginal },

    {
      path: "/purchase",
      // component: Purchase,
      redirect: { name: "home" },
      meta: { membership: false },
      children: [
        {
          name: "purchase.tokens",
          path: "tokens",
          beforeEnter: __redirectToOriginal, // component: PurchaseTokens
        },
        {
          name: "purchase.subscription",
          path: "subscription",
          beforeEnter: __redirectToOriginal, //component: PurchaseSubscription
        },
      ],
    },

    {
      path: "/:username",
      children: [
        { name: "model.username", path: "", beforeEnter: __redirectToOriginal },
        { name: "model.post", path: "post/:post", component: ModelPost },
      ],
    },

    { name: 'error404', path: '/:pathMatch(.*)*', component: PageNotFound },
  ],
};
